// MapColoring.js
// Universal color engine for ANY map (World, PR, USA, Colorado, etc.)

// ⭐ 1. Build visitedSet from visitedList (supports categories)
export function buildVisitedSet(visitedList) {
  if (!visitedList) {
    return { withVideo: new Set(), noVideo: new Set() };
  }

  const normalize = (name) =>
    String(name).toLowerCase().replace(/\s+/g, "");

  return {
    withVideo: new Set((visitedList.withVideo || []).map(normalize)),
    noVideo: new Set((visitedList.noVideo || []).map(normalize)),
  };
}

// ⭐ 2. Generate CSS for visited (dark blue + light blue) + default (green)
export function buildVisitedCSS(visitedSet, svgClass) {
  if (!svgClass) return "";

  let css = `
    /* Default green */
    .${svgClass} path { fill: rgba(45, 211, 30, 0.97); }
  `;

  /* Light blue for visited WITHOUT video */
  visitedSet.noVideo.forEach((idLower) => {
    css += `
      .${svgClass} #${idLower} { fill: rgba(102, 179, 255, 1) !important; }
    `;
  });

  /* Dark blue for visited WITH video */
  visitedSet.withVideo.forEach((idLower) => {
    css += `
      .${svgClass} #${idLower} { fill: rgba(24, 103, 250, 0.97) !important; }
    `;
  });

  return css;
}

// ⭐ 3. Generate CSS for highlight (red)
export function buildHighlightCSS(id, svgClass) {
  if (!id || !svgClass) return "";

  return `
    .${svgClass} #${id} { fill: red !important; }
  `;
}
